import type { NavItem } from 'admin/src/components/ui/Shell/ShellNav';
import { type ReactNode, createContext, useContext } from 'react';
import type { Theme } from 'shared/src/types';

export type NavAction = {
  icon?: ReactNode;
  label: string;
  onClick: () => void;
};

export type ShellContextProps = {
  title: string;
  showTitle?: boolean;
  nav: NavItem[];
  navAction?: NavAction;
  activeNav?: NavItem;
  theme: Theme;
  headerRight?: ReactNode;
  sidebarFooterSlot?: ReactNode;
  hideNav?: boolean;
  sidebar: {
    open: boolean;
    setOpen: (open: boolean) => void;
    openMobile: boolean;
    setOpenMobile: (open: boolean) => void;
  };
  help: {
    enabled: boolean;
    open: boolean;
    setOpen: (open: boolean) => void;
  };
};

const noop = () => {};

const ShellContext = createContext<ShellContextProps>({
  nav: [],
  title: '',
  showTitle: true,
  theme: 'sa',
  hideNav: false,
  sidebar: { open: true, setOpen: noop, openMobile: false, setOpenMobile: noop },
  help: { enabled: false, open: false, setOpen: noop },
});

export function useShell() {
  const context = useContext(ShellContext);

  if (!context) {
    throw new Error('useShell must be used within a ShellContext.');
  }

  return context;
}

export default ShellContext;
